import { Form, Input } from 'antd'
import { FC } from 'react'
import getMaxWidthOfMaterial from '../../../../../../../../../../helpers/fields-calculation/stamps/get-max-width-of-material'
import useWatch from '../../../hooks/form/use-watch'

interface MaxWidthProps {}

const MaxWidth: FC<MaxWidthProps> = () => {
    const width = useWatch('width')
    const floods = useWatch('floods')

    return (
        <Form.Item label={'Макс. ширина материала'}>
            <Input value={getMaxWidthOfMaterial({ width, floods })} disabled />
        </Form.Item>
    )
}

export default MaxWidth
